(() => {
  'use strict';
  const form = document.getElementById('rail-run-form');
  if (!form) return;
  const rows = document.getElementById('rail-run-rows');
  const result = document.getElementById('rail-run-result');
  const error = document.getElementById('rail-run-error');
  const add = document.getElementById('rail-add-run');
  let nextId = 0;
  let totalFeet = null;
  function invalidate() { totalFeet = null; result.hidden = true; error.hidden = true; }
  function addRow() {
    if (rows.children.length >= 20) return;
    const id = ++nextId;
    const row = document.createElement('div');
    row.className = 'rail-run';
    row.innerHTML = `<span class="rail-run__name">Run ${id}</span><label for="rail-ft-${id}">Feet<input id="rail-ft-${id}" type="number" inputmode="numeric" min="0" max="500" step="1" placeholder="0" data-feet></label><label for="rail-in-${id}">Inches<input id="rail-in-${id}" type="number" inputmode="decimal" min="0" max="11.99" step="0.01" placeholder="0" data-inches></label><button type="button" aria-label="Remove run ${id}">Remove</button>`;
    row.querySelector('button').addEventListener('click', () => { row.remove(); add.disabled = false; invalidate(); add.focus(); });
    rows.append(row);
    add.disabled = rows.children.length >= 20;
    invalidate();
    return row;
  }
  add.addEventListener('click', () => addRow()?.querySelector('input').focus());
  form.addEventListener('input', event => { event.target.removeAttribute('aria-invalid'); invalidate(); });
  form.addEventListener('submit', event => {
    event.preventDefault();
    invalidate();
    let inches = 0;
    let invalid = null;
    for (const row of rows.children) {
      const feet = row.querySelector('[data-feet]');
      const inch = row.querySelector('[data-inches]');
      for (const field of [feet, inch]) {
        field.removeAttribute('aria-invalid');
        if (!field.checkValidity() || !Number.isFinite(Number(field.value))) invalid ||= field;
      }
      inches += Number(feet.value) * 12 + Number(inch.value);
    }
    if (invalid || inches < 12 || inches > 6000) {
      error.textContent = invalid ? 'Use whole feet from 0 to 500 and decimal inches from 0 to 11.99.' : 'Enter level railing runs totaling 1 to 500 feet.';
      error.hidden = false;
      if (invalid) { invalid.setAttribute('aria-invalid', 'true'); invalid.focus(); }
      else rows.querySelector('input')?.focus();
      return;
    }
    // Hundredths of an inch avoid floating-point remainder artifacts.
    const hundredths = Math.round(inches * 100);
    const wholeFeet = Math.floor(hundredths / 1200);
    const remainingInches = (hundredths % 1200) / 100;
    totalFeet = (hundredths / 1200).toFixed(2);
    document.getElementById('rail-run-total').textContent = `${wholeFeet} ft ${remainingInches} in total (${totalFeet} decimal ft)`;
    result.hidden = false;
  });
  document.getElementById('rail-use-total').addEventListener('click', () => {
    if (totalFeet === null) return;
    const input = document.getElementById('calc-length');
    if (!input) return;
    input.value = totalFeet;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    document.getElementById('calc-output').style.display = 'none';
    const placeholder = document.getElementById('calc-placeholder');
    placeholder.style.display = '';
    placeholder.querySelector('p').textContent = 'Your measured total is ready. Review height, finish and corners, then calculate.';
    document.getElementById('calc-unavailable-quote').hidden = true;
    input.focus({ preventScroll: true });
    document.getElementById('railing-calculator').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });
  for (let i = 0; i < 3; i++) addRow();
})();
